import React from "react";
import { Checkbox } from "material-ui";
import {
  lighten,
  darken,
  getLuminance
} from "material-ui/utils/colorManipulator";
import { IS_MOBILE, getColorForTag } from "../../util";
import assign from "lodash/assign";

import Tooltip from "./tooltip.jsx";

class Tag extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    };

    this.onClick = this.onClick.bind(this);
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object
    };
  }

  onClick(e) {
    this.props.onClick(e);
    e.stopPropagation();
    e.preventDefault();
  }

  getStyles() {
    return {
      tag: {
        fontSize: 12,
        lineHeight: "1.4",
        background: "#ccc",
        display: "inline-block",
        color: "#000",
        position: "relative",
        padding: "3px 6px",
        marginRight: 5,
        marginTop: 5,
        textDecoration: "none",
        border: "1px solid",
        zIndex: 999
      },
      hovered: {
        opacity: 0.7
      }
    };
  }

  render() {
    var styles = this.getStyles(),
      { content, disabled, checkable, tooltip, onClick } = this.props,
      { hovered } = this.state;

    // The "content" property can be either an object { name: xx, color: yy } or a string, so we support
    // both cases (by converting the string to an object).
    if (typeof content === "string") {
      content = {
        name: content
      };
    }

    // If tooltip option is a function, call it with current tag label
    if (typeof tooltip === "function") {
      tooltip = tooltip(content.name);
    }

    // Set color
    var color = getColorForTag(content, disabled, false, this.context.tenant),
      tagStyle = Object.assign({}, styles.tag);

    if (this.context.tenant.schedule_invert_colors) {
      tagStyle.background = lighten(color, 0.6);
      tagStyle.borderColor = lighten(color, 0.2);
    } else {
      tagStyle.background = color;
      tagStyle.borderColor = darken(color, 0.05);
    }

    if (disabled) {
      tagStyle.fontStyle = "italic";
      tagStyle.color = "rgb(124, 124, 124)";
    }

    if (checkable || onClick) {
      tagStyle.cursor = "pointer";
    }

    if (checkable && !disabled) {
      tagStyle.fontWeight = "bold";
    }

    if (getLuminance(tagStyle.background) < 0.5) {
      tagStyle.color = "#fff";
    }

    const onMouseEnter = !IS_MOBILE
      ? () => this.setState({ hovered: true })
      : undefined;
    const onMouseLeave = !IS_MOBILE
      ? () => this.setState({ hovered: false })
      : undefined;

    let tagBody = (
      <span
        className="Tag"
        style={Object.assign(
          {},
          tagStyle,
          onClick && hovered && styles.hovered
        )}
        onClick={onClick && this.onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {content.name}
      </span>
    );

    return checkable ? (
      <div
        style={this.props.style}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick && this.onClick}
      >
        {tagBody}
      </div>
    ) : tooltip ? (
      <span
        style={{ display: "inline-block", position: "relative" }}
        onClick={onClick && this.onClick}
      >
        {tagBody}
        {!IS_MOBILE && <Tooltip show={hovered} label={tooltip} />}
      </span>
    ) : (
      tagBody
    );
  }
}

export default Tag;



// WEBPACK FOOTER //
// ./src/app/components/partials/tag.jsx